function getColumnType(reportSchema) {
  const metricCategory = reportSchema.Columns.categories.find(item => item.type === 'MetricColumns');
  if (!metricCategory) {
    return {};
  }
  const columnType = {};
  metricCategory.options.forEach((item) => { columnType[item.key] = item.type; });
  return columnType;
}

function handleValue(value, type) {
  let result = null;
  if (value || value === 0 || value === '0') {
    result = type === 'Percent' ? Number((value * 100).toFixed(2)) : value;
  }
  return result;
}

export function apiToUiFormats(conditionalFormatsList, entitySchema) {
  const columnType = getColumnType(entitySchema);
  const conditionalFormats = {};
  conditionalFormatsList.forEach((item) => {
    if (!conditionalFormats[item.ColumnName]) {
      conditionalFormats[item.ColumnName] = [];
    }
    conditionalFormats[item.ColumnName].push({
      operator: item.Type,
      value: handleValue(Number(item.Value), columnType[item.ColumnName]),
      value2: handleValue(Number(item.Value2), columnType[item.ColumnName]),
      color: item.FillColor,
    });
  });
  return conditionalFormats;
}

export function uiToApiFormats(conditionalFormats, reportSchema) {
  const columnType = getColumnType(reportSchema);
  const columnNameSet = Object.keys(conditionalFormats);
  const conditionalFormatsList = [];
  columnNameSet.forEach((key) => {
    conditionalFormats[key].forEach((condition) => {
      const format = {
        FillColor: condition.color,
        ColumnName: key,
        Value: columnType[key] === 'Percent' ? condition.value / 100 : condition.value,
        Type: condition.operator,
      };
      if (condition.operator === 'Between') {
        format.Value2 = columnType[key] === 'Percent' ? condition.value2 / 100 : condition.value2;
      }
      conditionalFormatsList.push(format);
    });
  });
  return conditionalFormatsList;
}

